var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MdField as MaterialField } from '@bytebrand/fe-ui-core-autobahn/compat';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import SvgClosedLockIcon from '../../../ui/SVG/ClosedLockIcon';
import form from '../formConfigs/LoginFormConfig';
import styles from '../modals.styl';
let LoginForm = class LoginForm extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "componentDidMount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { email } = this.props;
                if (email) {
                    form.$('email').set(email);
                }
            }
        });
        Object.defineProperty(this, "onSubmit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onError, onSuccess } = this.props;
                form.submit()
                    .then((form) => {
                    if (form.hasError) {
                        onError();
                    }
                    else {
                        onSuccess();
                    }
                })
                    .catch(() => {
                });
            }
        });
        Object.defineProperty(this, "redirect", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const { onError, onRedirect } = this.props;
                form.submit()
                    .then((form) => {
                    if (form.hasError) {
                        onError();
                    }
                    else {
                        onRedirect();
                    }
                })
                    .catch(() => {
                });
            }
        });
        Object.defineProperty(this, "onCloseClick", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                const { onClose } = this.props;
                event.preventDefault();
                onClose();
            }
        });
        Object.defineProperty(this, "onBlur", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e, field) => {
                e.preventDefault();
                field.validate().then((subField) => {
                    if (!field.isValid) {
                        subField.showErrors(true);
                    }
                });
            }
        });
        Object.defineProperty(this, "onFocus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (e, field) => {
                e.preventDefault();
                field.validate();
            }
        });
        this.state = {
            email: ''
        };
    }
    render() {
        const { t, authStore, onResetPassword } = this.props;
        const { isAuthFetching } = authStore;
        return (React.createElement("div", { className: styles.loginForm },
            React.createElement("div", { className: styles.fieldsWrapper },
                React.createElement(MaterialField, { onChange: value => form.$('email').onChange(value, form.$('email').name), label: t(`CheckoutPage:contactInformation:fieldLabels.email`), value: form.$('email').value, ...{
                        onBlur: (e) => this.onBlur(e, form.$('email')),
                        onFocus: (e) => this.onFocus(e, form.$('email'))
                    }, type: form.$('email').type, name: "email", autoComplete: "username", error: form.$('email').hasError && form.$('email').error, helperText: form.$('email').showError ? form.$('email').error : '', classNameInput: styles.fieldInput }),
                React.createElement(MaterialField, { onChange: value => form.$('password').onChange(value, form.$('password').name), label: t(`CheckoutPage:contactInformation.fieldLabels.password`), value: form.$('password').value, ...{
                        onBlur: (e) => this.onBlur(e, form.$('password')),
                        onFocus: (e) => this.onFocus(e, form.$('password'))
                    }, type: form.$('password').type, name: "password", autoComplete: "current-password", error: form.$('password').hasError && form.$('password').error, helperText: form.$('password').showError ? form.$('password').error : '', classNameInput: styles.fieldInput })),
            React.createElement("div", { className: styles.resetWrapper },
                React.createElement("span", { className: styles.pseudoLink, onClick: onResetPassword }, t('modals:offerRequest.resetPassword'))),
            React.createElement(Button, { className: styles.confirm, variant: 'filled', onClick: this.onSubmit, disabled: isAuthFetching }, isAuthFetching ? React.createElement("span", { className: 'auth-spinner', style: { width: 18, height: 18, borderWidth: 2 } }) : t('CheckoutPage:requestWithoutObligation')),
            React.createElement(Button, { className: styles.btnLink, variant: 'outlined', onClick: this.redirect }, t('CheckoutPage:onlineCheckoutModal.redirectBtn')),
            React.createElement("span", { className: styles.securityDescription },
                React.createElement(SvgClosedLockIcon, { className: styles.closedLockIcon }),
                React.createElement("span", null, t('modals:offerRequest.securityDescription')))));
    }
};
LoginForm = __decorate([
    inject('authStore'),
    observer,
    __metadata("design:paramtypes", [Object])
], LoginForm);
export default LoginForm;
